import axios from 'axios';
const FileDownload = require('js-file-download');

/**
 * Function to get a wording document.
 * @param {any} quoteId - The ID of the quote for which the document is to be retrieved.
 * @param {any} policyWordingUrl - The url of the wording for which the document is to be retrieved.
 * @param {any} policyWordingName - The name of the wording for which the document is to be retrieved.
 * @param {boolean} getDownload - (Optional) A boolean indicating whether to download the document.
 * @returns {Promise} A Promise that resolves with the document if successful.
 */
export const getWording = async (quoteId: any, policyWordingUrl: any, policyWordingName: any, getDownload?: boolean) => {
  try {
    await axios
        .get(policyWordingUrl, {
            responseType: 'blob',
        })
        .then((response) => {
            if (getDownload === true) {
              FileDownload(response.data, `quote-${quoteId}-${policyWordingName}.pdf`);
            }

            // Return the Blob containing the document.
            return response.data;
        });
  } catch (error: any) {
    console.log('Error downloading policy wordings', error);
    throw new Error(error);
  }
};